// parallax.js
//@ts-nocheck
import { gsap } from 'gsap';

const parallaxElements = [];

let mouseX = 0;
let mouseY = 0;

const defaultDuration = 1.5;
const MOBILE_BREAKPOINT = 768;

const isBrowser = typeof window !== 'undefined';
const isMobile = () => isBrowser && window.innerWidth < MOBILE_BREAKPOINT;

function handleMouseMove(event) {
	if (!isBrowser || isMobile()) return;

	const { innerWidth, innerHeight } = window;
	mouseX = (event.clientX - innerWidth / 2) / innerWidth;
	mouseY = (event.clientY - innerHeight / 2) / innerHeight;

	parallaxElements.forEach(({ node, factor, duration }) => {
		const translateX = mouseX * factor * 50;
		const translateY = mouseY * factor * 50;
		gsap.to(node, {
			x: translateX,
			y: translateY,
			ease: 'power2.out',
			duration: duration,
			overwrite: 'auto'
		});
	});
}

export function parallax(node, options = {}) {
	if (!isBrowser) {
		return {
			destroy() {}
		};
	}

	const { factor = 1, duration = defaultDuration } =
		typeof options === 'number' ? { factor: options } : options;

	if (isMobile()) {
		return {
			destroy() {}
		};
	}

	if (parallaxElements.length === 0) {
		window.addEventListener('mousemove', handleMouseMove);
	}

	parallaxElements.push({ node, factor, duration });

	return {
		destroy() {
			if (!isBrowser) return;
			
			const index = parallaxElements.findIndex((el) => el.node === node);
			if (index !== -1) parallaxElements.splice(index, 1);

			if (parallaxElements.length === 0) {
				window.removeEventListener('mousemove', handleMouseMove);
			}
		}
	};
}
